import Immutable from 'immutable';
import {
  FLAG_GETTING_CABIN_CREW_MOVEMENT_HISTORY,
  GET_CABIN_CREW_MOVEMENT_HISTORY_LIST,
  CLEAR_CABIN_CREW_MOVEMENT_HISTORY_LIST,
  FLAG_CABIN_CREW_MOVEMENT_HISTORY_ACTIVITY,
  GET_CABIN_CREW_MOVEMENT_HISTORY,
  CLEAR_CABIN_CREW_MOVEMENT_HISTORY,
} from '../../../actions/types/traffic/CabinCrewMovementHistory';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.List(),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_CABIN_CREW_MOVEMENT_HISTORY:
      return state.setIn(['all', 'loading'], payload);
    case GET_CABIN_CREW_MOVEMENT_HISTORY_LIST:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_CABIN_CREW_MOVEMENT_HISTORY_LIST:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_CABIN_CREW_MOVEMENT_HISTORY_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_CABIN_CREW_MOVEMENT_HISTORY:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_CABIN_CREW_MOVEMENT_HISTORY:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};